import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addFulfilment } from '../../Actions/AddFulfilment';
import { calculateAmount } from '../../Helper';
import { required, email, phone } from '../../Validation/GeneralValidators';
import { range } from '../../Validation/DonationFormValidators';
import Form from 'react-validation/build/form';
import './WishDonateForm.scss';
import { Link } from 'react-router-dom';

import {
  DonationInput as Input,
  DonationButton as Button,
  DonationCheckbox as Checkbox,
  DonationCurrencyInput as CurrencyInput
} from '../../Validation/Form';

class WishDonateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: '',
      lastname: '',
      email: '',
      telephone: '',
      agb: false,
      amount: 1.0
    };
  }

  performDonation = event => {
    event.preventDefault();
    let fulfilment = {
      donator: {
        firstname: this.state.firstname,
        lastname: this.state.lastname,
        telephone: this.state.telephone,
        email: this.state.email
      },
      wishId: this.props.wish.id,
      amount:
        this.props.wish.purchase === 'direct' ? null : Number(this.state.amount)
    };
    this.props.addFulfilment(fulfilment, this.props.child);
  };

  handleInputChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  };

  handleAmountChange = value => {
    this.setState({
      amount: value.floatValue
    });
  };

  renderDonation(wish, child) {
    let calcAmount = calculateAmount(wish.amount, wish.amountCollected);
    return (
      <React.Fragment>
        <div className="form-inline col-md-12 donation-row text-center">
          <p className="lead-text">
            Es fehlen nur noch {calcAmount}
            €.
          </p>
          <div className="input-group col-md-12 flex-group">
            <CurrencyInput
              min="0"
              max={wish.amount - wish.amountCollected}
              value={this.state.amount}
              onValueChange={this.handleAmountChange}
              validations={[required, range]}
              amount={this.state.amount}
            />
            <Button classes="donation-button" onClick={this.performDonation}>
              DONATE
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderDirect() {
    return (
      <div className="form-inline col-md-12 text-center donation-row">
        <div className="form-group donation-input-group">
          <Button
            classes="donation-button direct"
            onClick={this.performDonation}
          >
            SPENDEN
          </Button>
        </div>
      </div>
    );
  }

  render() {
    if (!this.props.wish || !this.props.child) {
      return null;
    }

    return (
      <Form onSubmit={this.performDonation} ref={c => (this.form = c)}>
        <div className="row">
          <Input
            label={'Vorname'}
            name={'firstname'}
            value={this.state.firstname}
            onChange={this.handleInputChange}
            type="text"
            validations={[required]}
            sublabel={'(Pflichtfeld)'}
          />
          <Input
            label={'Nachname'}
            name={'lastname'}
            value={this.state.lastname}
            onChange={this.handleInputChange}
            type="text"
            validations={[]}
          />
        </div>
        <div className="row">
          <Input
            label={'E-Mail'}
            name={'email'}
            value={this.state.email}
            onChange={this.handleInputChange}
            type="email"
            validations={[required, email]}
            sublabel={'(Pflichtfeld)'}
          />
          <Input
            label={'Telefonnummer'}
            name={'telephone'}
            value={this.state.telephone}
            onChange={this.handleInputChange}
            validations={[required, phone]}
            type="number"
            pattern="[0-9]*"
            sublabel={'(Pflichtfeld)'}
          />
        </div>
        <div className="row">
          <Checkbox
            label={[
              'Ja, ich stimme den ',
              <Link
                key="id_link_dataprotection"
                target="_blank"
                rel="noopener noreferrer"
                to="/howto"
              >
                Teilnahmebedingungen
              </Link>,
              ' zu.'
            ]}
            name={'agb'}
            type="checkbox"
            checked={this.state.agb}
            value={this.state.agb}
            onChange={this.handleInputChange}
            validations={[required]}
          />
        </div>
        <div className="row">
          {this.props.wish.purchase === 'direct'
            ? this.renderDirect()
            : this.renderDonation(this.props.wish, this.props.child)}
        </div>
      </Form>
    );
  }
}

const mapStateToProps = state => {
  return {
    fetching: state.addFulfilmentReducer.fetching,
    childrenList: state.childrenListReducer.list
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addFulfilment: (fulfilment, child) =>
      dispatch(addFulfilment(fulfilment, child))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WishDonateForm);



// WEBPACK FOOTER //
// ./src/Containers/WishElements/WishDonateForm.js